"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripHtml = void 0;
function stripHtml(html) {
    if (!html)
        return '';
    if (typeof window !== 'undefined' && window.DOMParser) {
        const doc = new window.DOMParser().parseFromString(html, 'text/html');
        return (doc.body.textContent ?? '').trim();
    }
    return html.replace(/<[^>]+>/g, '').trim();
}
exports.stripHtml = stripHtml;
